import React from 'react'

import Layout from '../components/Layout'
import Text from '../components/Text'
import Button from '../components/Button'
import ActionBar from '../components/ActionBar'
import BackButton from '../components/BackButton'

export default ({ healthStatus, onSetHealthStatus, onNext, onBack }) => {
  const isSelected = status => (healthStatus === null ? null : healthStatus === status)

  return (
    <Layout>
      <Layout>
        <Text large>Start by selecting your health status</Text>
      </Layout>

      <Layout>
        <Button
          onClick={() => onSetHealthStatus('healthy')}
          selected={isSelected('healthy')}
          fullWidth
        >
          I consider myself healthy
        </Button>

        <Button
          onClick={() => onSetHealthStatus('suspect')}
          selected={isSelected('suspect')}
          fullWidth
        >
          I suspect I might have COVID-19
        </Button>

        <Button onClick={() => onSetHealthStatus('covid')} selected={isSelected('covid')} fullWidth>
          I have been diagnosed with COVID-19
        </Button>

        <Button
          onClick={() => onSetHealthStatus('recovered')}
          selected={isSelected('recovered')}
          fullWidth
        >
          I was diagnosed with COVID-19 and recovered
        </Button>
      </Layout>

      <ActionBar active={healthStatus}>
        <BackButton onClick={onBack} />
        <Button onClick={onNext} disabled={!healthStatus}>
          Next
        </Button>
      </ActionBar>
    </Layout>
  )
}
